import { render, staticRenderFns } from "./VueText.vue?vue&type=template&id=32c2a7f7"
import script from "./VueText.vue?vue&type=script&lang=js"
export * from "./VueText.vue?vue&type=script&lang=js"
import style0 from "./VueText.vue?vue&type=style&index=0&id=32c2a7f7&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c2a7f7')) {
      api.createRecord('32c2a7f7', component.options)
    } else {
      api.reload('32c2a7f7', component.options)
    }
    module.hot.accept("./VueText.vue?vue&type=template&id=32c2a7f7", function () {
      api.rerender('32c2a7f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueText/VueText.vue"
export default component.exports